export interface INoticeBoardPosts {
  postId: string;
  postDescription: string;
  postAttachment: any;
  postUsername: string;
  postUserProfile: string;
  postShared: boolean;
  postSharedId: string;
  postUserId: string;
  postAddDate: Date;
  postValidDate: Date;
  postComments: IPostComments[];
  postLikes: IPostLikes[];
  isIncident?: boolean;
  isPublic?: boolean;
  isApproved?: boolean;
  isPending?: boolean;
  approvedBy?: string;
  approvedByName?: string;
  approvedDateTime?: Date;
  flaggedPost?: boolean;
  hidePost?: boolean;
  postReports?: IPostReports[];
}
export interface IPostReports {
  reportId: string;
  postId: string;
  reportDate: Date;
  reportDescription: string;
  reportReason: string;
  reportStatus: string;
  reportedBy: string;
  reportedByName: string;
  reviewDate: string;
  reviewNotes: string;
  reviewedBy: string;
  reviewedByName: string;
  actionTaken: string;
}
export enum PostStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum ReportStatus {
  PENDING = 'pending',
  REVIEWED = 'reviewed', //
  RESOLVED = 'resolved', // Resolved the flags
  DISMISSED = 'dismissed', // Removed the flags
  BANNED = 'banned', //banned the authror
}
export interface IPostComments {
  postId: string;
  commentId: string;
  commentText: string;
  commentUsername: string;
  commentUserId: string;
  commentUserProfile: string;
  commentAddDate: Date;
  isAuto: string;
  isIncident: string;
  isVisitor: string;
  incidentEvidence?: string;
  isMultiple?: boolean;
  parsedImages?: any;
}

export interface IPostLikes {
  postId: string;
  likeId: string;
  userId: string;
  likeUsername: string;
  likeAddDate: Date;
  userProfile: string;
}

// Updated interfaces based on your provided models
// export interface INoticeBoardPosts {
//   postId: string;
//   postDescription: string;
//   postAttachment: string;
//   postUsername: string;
//   postUserProfile: string;
//   postShared: boolean;
//   postSharedId: string;
//   postUserId: string;
//   postAddDate: Date;
//   postValidDate: Date;
//   postComments: IPostComments[];
//   postLikes: IPostLikes[];
//   isIncident?: boolean;
//   isPublic?: boolean;
//   isApproved?: boolean;
//   isPending?: boolean;
//   approvedBy?: string;
//   approvedByName?: string;
//   approvedDateTime?: Date;
//   flaggedPost?: boolean;
//   hidePost?: boolean;
//   postReports?: IPostReports[];
// }

// export interface IPostReports {
//   reportId: string;
//   postId: string;
//   reportDate: Date;
//   reportDescription: string;
//   reportReason: string;
//   reportStatus: string;
//   reportedBy: string;
//   reportedByName: string;
//   reviewDate: string;
//   reviewNotes: string;
//   reviewedBy: string;
//   reviewedByName: string;
//   actionTaken: string;
// }

// export enum PostStatus {
//   PENDING = 'pending',
//   APPROVED = 'approved',
//   REJECTED = 'rejected',
// }

// export enum ReportStatus {
//   PENDING = 'pending',
//   REVIEWED = 'reviewed',
//   RESOLVED = 'resolved',
//   DISMISSED = 'dismissed',
// }

// export interface IPostComments {
//   postId: string;
//   commentId: string;
//   commentText: string;
//   commentUsername: string;
//   commentUserId: string;
//   commentUserProfile: string;
//   commentAddDate: Date;
//   isAuto: string;
//   isIncident: string;
//   isVisitor: string;
//   incidentEvidence?: string;
//   isMultiple?: boolean;
//   parsedImages?: any;
// }

// export interface IPostLikes {
//   postId: string;
//   likeId: string;
//   userId: string;
//   likeUsername: string;
//   likeAddDate: Date;
//   userProfile: string;
// }

// interface User {
//   userId: string;
//   userName: string;
//   userRole: 'Admin' | 'Moderator' | 'User';
// }
